var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"multiple":_vm.multiple,"label":_vm.label,"items":_vm.all_tenants,"item-value":"ID","item-text":"Tenant","rules":_vm.rules,"prepend-icon":"fas fa-building"},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }